import { render } from "./SizeOptions.vue?vue&type=template&id=295efc81&scoped=true"
import script from "./SizeOptions.vue?vue&type=script&lang=js"
export * from "./SizeOptions.vue?vue&type=script&lang=js"

import "./SizeOptions.vue?vue&type=style&index=0&id=295efc81&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295efc81"]])

export default __exports__